import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "paragraph-styles-icon",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.16665 4.3728C8.82147 4.3728 8.54165 4.65262 8.54165 4.9978C8.54165 5.34298 8.82147 5.6228 9.16665 5.6228H12.7099V15.002C12.7099 15.3471 12.9898 15.627 13.3349 15.627C13.6801 15.627 13.9599 15.3471 13.9599 15.002V5.6228H17.5035C17.8486 5.6228 18.1285 5.34298 18.1285 4.9978C18.1285 4.65262 17.8486 4.3728 17.5035 4.3728H9.16665Z" }, null, -1),
    _createElementVNode("path", { d: "M6.39728 8.95753H8.74916C9.09433 8.95753 9.37416 8.67771 9.37416 8.33253C9.37416 7.98736 9.09433 7.70753 8.74916 7.70753H2.91339C2.56821 7.70753 2.28839 7.98736 2.28839 8.33253C2.28839 8.67771 2.56821 8.95753 2.91339 8.95753H5.14728V15.002C5.14728 15.3472 5.4271 15.627 5.77228 15.627C6.11746 15.627 6.39728 15.3472 6.39728 15.002V8.95753Z" }, null, -1)
  ])))
}
export default { render: render }